import { parseValue } from 'common/include';
import type { IUniversalSearchEgm } from 'services/casino';
import { egmMetaLine, pillColors } from 'lib/universalSearchView';

/**
 * EGM card in the Explore card look (game name, title, "#display id · Bank",
 * metric pill colored by ntile). A lightweight copy of the HotListReport card
 * markup: that component is bound to the casino in view, these cards span
 * every casino.
 */
type Props = {
  egm: IUniversalSearchEgm;
  metricKey: string;
  /** Casino label (By Manufacturer grouping). */
  casinoName?: string;
  /** False when the casino has no Mongo metric source: no pill at all. */
  showMetric?: boolean;
  onSelect: () => void;
};

export function formatUniversalMetric(value: number | null | undefined, metricKey: string): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  // parseValue is typed `any` in common/include; it returns the display string.
  const format = parseValue as (v: number, insight: string) => unknown;
  const out = format(value, metricKey);
  return out === undefined || out === null || out === '' ? '—' : String(out);
}

const UniversalSearchCard = ({ egm, metricKey, casinoName, showMetric = true, onSelect }: Props) => {
  const colors = pillColors(egm.metric ? egm.metric.ntile : null);
  const text = formatUniversalMetric(egm.metric ? egm.metric.value : null, metricKey);
  const meta = egmMetaLine(egm);
  return (
    <button type="button" className="us-card" onClick={onSelect}>
      <div className="us-card__info">
        <div className="us-card__name">{egm.gameName || egm.title || 'Unknown game'}</div>
        {egm.title && egm.title !== egm.gameName ? <div className="us-card__theme">{egm.title}</div> : null}
        <div className="us-card__meta">
          {[meta, casinoName, egm.manufacturer].filter(Boolean).join(' · ')}
        </div>
      </div>
      {showMetric ? (
        <span className="us-card__pill" style={{ background: colors.background, color: colors.color }}>
          {text}
        </span>
      ) : null}
    </button>
  );
};

export default UniversalSearchCard;
